import React from "react";
import GatsbyConfig from "../../../gatsby-config.js";
import {
  saveData,
  validateRequired,
  validateEmail,
  countries,
} from "../../utils/forms";
import {
  getEl,
  setInLocal,
  trackEvent,
  getParamFromQueryString,
} from "../../utils/app-helpers";
import SiteFooter from "../partials/site-footer";
import HelmetWrapper from "../partials/helmet-wrapper";
import SiteHeader from "../partials/site-header";

const { siteMetadata: config } = GatsbyConfig;

export default class BookPage extends React.Component {
  static BLANK_FORM_DATA = {
    firstName: "",
    lastName: "",
    birthDay: "",
    birthMonth: "",
    birthYear: "",
    firstNameSpouse: "",
    lastNameSpouse: "",
    birthDaySpouse: "",
    birthMonthSpouse: "",
    birthYearSpouse: "",
    address: "",
    city: "",
    region: "",
    zip: "",
    country: "",
    email: "",
    phone: "",
    promo: "",
    upgraded: "",
  };

  componentDidMount() {
    const { trip } = this.props;
    const tripData = config.trips[trip];

    if (tripData.soldOut) return;
    setInLocal("lsg.last-viewed-trip", trip);
    this.validateDataKeys = Object.keys(BookPage.BLANK_FORM_DATA).slice(0, -2);
    this.liveChecking = false;
    this.checkCompatability(true);
    setTimeout(window.scrollTo, 150, 0, 0);
  }

  saveAndNext() {
    this.data = saveData("lsg.book-data");
    if (
      validateRequired("lsg.book-data", this.validateDataKeys) &&
      validateEmail("lsg.book-data", ["email"])
    ) {
      const promo = getParamFromQueryString("promo", window.location.href);
      const room = config.trips[this.data.trip].rooms[this.data.room];
      const isValidPromo = Object.keys(room.prices).includes(promo);
      const queryString =
        isValidPromo && Object.keys(room.prices).includes(promo)
          ? `?promo=${promo}`
          : "";

      location.href = `/${this.props.trip}/checkout${queryString}`;
    } else {
      window.scrollTo(0, 0);
      this.liveChecking = true;
    }
  }

  onInputChange() {
    this.data = saveData("lsg.book-data");
    if (this.liveChecking) {
      validateRequired("lsg.book-data", this.validateDataKeys);
      validateEmail("lsg.book-data", ["email"]);
    }
  }

  onSelectChange(e) {
    e.target.parentNode.classList.add("has-value");
    this.data = saveData("lsg.book-data");
    if (this.liveChecking) {
      validateRequired("lsg.book-data", this.validateDataKeys);
      validateEmail("lsg.book-data", ["email"]);
    }
  }

  checkCompatability(updateDOM = false) {
    const bodyEl = getEl("body");
    const errorElIe = getEl("#error-ie");
    const errorElCookies = getEl("#error-cookies");
    const errorElLocalStorage = getEl("#error-local-storage");
    const bookFormEl = getEl("#book-form");
    let hasCookies = !!navigator.cookieEnabled;
    let hasClassList;
    let hasElForEach;
    let hasLocalStorage;
    try {
      hasClassList = typeof bodyEl.classList.add === "function";
    } catch (err) {
      hasClassList = false;
    }
    try {
      hasElForEach =
        typeof document.querySelectorAll("div").forEach === "function";
    } catch (err) {
      hasElForEach = false;
    }
    if (hasCookies) {
      try {
        localStorage.getItem("lsg.book-data");
        hasLocalStorage = true;
      } catch (err) {
        hasLocalStorage = false;
      }
    }
    const isCompatible = hasClassList && hasElForEach;

    if (updateDOM) {
      errorElIe.className = isCompatible
        ? `${errorElIe.className} hide`
        : errorElIe.className.replace(/\s+hide/i, "");

      if (hasCookies) {
        errorElLocalStorage.className = hasLocalStorage
          ? `${errorElLocalStorage.className} hide`
          : errorElLocalStorage.className.replace(/\s+hide/i, "");
      } else {
        errorElCookies.className = hasCookies
          ? `${errorElCookies.className} hide`
          : errorElCookies.className.replace(/\s+hide/i, "");
      }

      bookFormEl.className =
        isCompatible && hasCookies && hasLocalStorage
          ? bookFormEl.className.replace(/\s+hide/i, "")
          : `${bookFormEl.className} hide`;
    }
    return isCompatible && hasCookies && hasLocalStorage;
  }

  render() {
    const { trip } = this.props;
    if (!trip || typeof document === "undefined") return <main />;
    const tripData = config.trips[trip] || {};
    const title = `Book Today - ${tripData.name} ${tripData.year}`;
    const description =
      "Space is filling up fast, so book your space on the Love Song Couples " +
      `Getaway | ${tripData.name} ${tripData.year} today to guarantee your space.`;
    const query = {};
    this.props.location.search.split(/[?&]/g).forEach((pair) => {
      if (!pair) return;
      const parts = pair.split(/=/);
      query[parts[0]] = parts[1];
    });
    let data = { ...BookPage.BLANK_FORM_DATA };

    if (!tripData.soldOut && this.checkCompatability()) {
      const raw = localStorage.getItem("lsg.book-data");
      if (raw) data = JSON.parse(raw);

      data.trip = trip;
      data.room = query.room;
      data.pay = query.pay;
      try {
        localStorage.setItem("lsg.book-data", JSON.stringify(data));
      } catch (err) {}
      this.data = data;
    }

    const dayOptions = [];
    for (let d = 1; d <= 31; d++) {
      dayOptions.push(
        <option key={`day-${d}`} value={d}>
          {d}
        </option>
      );
    }
    const monthOptions = [
      <option key="month-1" value="Jan">
        Jan
      </option>,
      <option key="month-2" value="Feb">
        Feb
      </option>,
      <option key="month-3" value="Mar">
        Mar
      </option>,
      <option key="month-4" value="Apr">
        Apr
      </option>,
      <option key="month-5" value="May">
        May
      </option>,
      <option key="month-6" value="Jun">
        Jun
      </option>,
      <option key="month-7" value="Jul">
        Jul
      </option>,
      <option key="month-8" value="Aug">
        Aug
      </option>,
      <option key="month-9" value="Sep">
        Sep
      </option>,
      <option key="month-10" value="Oct">
        Oct
      </option>,
      <option key="month-11" value="Nov">
        Nov
      </option>,
      <option key="month-12" value="Dec">
        Dec
      </option>,
    ];
    const yearOptions = [];
    for (let n = 1999; n > 1900; n--) {
      yearOptions.push(
        <option key={n} value={n}>
          {n}
        </option>
      );
    }

    const countryOptions = countries.map((country, c) => {
      if (country === "—") {
        return (
          <option key={`country-${c}`} disabled selected>
            ———
          </option>
        );
      } else {
        return (
          <option key={`country-${c}`} value={country}>
            {country}
          </option>
        );
      }
    });

    const room = tripData.rooms[query.room];
    const promo = getParamFromQueryString("promo", window.location.href);
    const upgraded = getParamFromQueryString("upgraded", window.location.href);
    const isValidPromo = Object.keys(room.prices).includes(promo);
    const isValidUpgrade =
      upgraded && Object.keys(tripData.rooms).includes(upgraded);

    trackEvent("InitiateCheckout", {
      content_name: `${tripData.name} ${tripData.year}`,
    });
    return (
      <div className={`page-book trip-${trip}`}>
        <HelmetWrapper metaTitle={title} metaDescription={description} />
        <SiteHeader
          trip={trip}
          step="3"
          lock
          lockLogo={promo === "onlocation"}
        />
        {tripData.soldOut ? (
          <main>
            <p className="soldout-notice">Trip Sold Out</p>
          </main>
        ) : (
          <main className="form">
            <div id="error-ie" className="error hide">
              <p>
                <strong>
                  Your browser (Internet Explorer, Edge, Etc.) is not fully
                  supported.
                </strong>
              </p>
              {config.showPhone ? (
                <p>
                  To complete your purchase, please try using one of our
                  supported <br />
                  browsers (Chrome, Firefox or Safari), or give us a call at{" "}
                  <br />
                  <strong>{config.phone}</strong> {config.officeHours}. Thank
                  you.
                </p>
              ) : (
                <p>
                  To complete your purchase, please try using one of our
                  supported <br />
                  browsers (Chrome, Firefox or Safari), email us at <br />
                  <a href={`mailto:${config.email}`}>{config.email}</a>. Thank
                  you.
                </p>
              )}
            </div>
            <div id="error-cookies" className="error hide">
              <p>
                <strong>
                  Your browser is not supported in its current configuration.
                </strong>
              </p>
              {config.showPhone ? (
                <p>
                  If you are using incognito mode, private browsing mode, or
                  have <br />
                  cookies turned off, browsing the site normally with cookies
                  turned on <br />
                  should resolve the issue. If not, please call us at <br />
                  <strong>{config.phone}</strong> {config.officeHours}. Thank
                  you.
                </p>
              ) : (
                <p>
                  If you are using incognito mode, private browsing mode, or
                  have <br />
                  cookies turned off, browsing the site normally with cookies
                  turned on <br />
                  should resolve the issue. If not, please email at <br />
                  <a href={`mailto:${config.email}`}>{config.email}</a>. Thank
                  you.
                </p>
              )}
            </div>
            <div id="error-local-storage" className="error hide">
              <p>
                <strong>
                  Your browser is not supported in its current configuration.
                </strong>
              </p>
              <p>
                If you are using an incognito or private browsing mode,
                <br />
                browsing the site normally may resolve the issue.
              </p>
            </div>
            <form
              id="book-form"
              className="wrap"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="content">
                <h2>Traveler Information</h2>
                <fieldset>
                  <legend>You</legend>
                  <p className="field field-split split-name">
                    <input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      autoComplete="given-name"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.firstName}
                    />
                    <input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      autoComplete="family-name"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.lastName}
                    />
                  </p>
                  <p className="field field-split split-birth">
                    <span
                      className={
                        data.birthMonth ? "has-value select" : "select"
                      }
                    >
                      <select
                        name="birthMonth"
                        autoComplete="bday-month"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.birthMonth || null}
                      >
                        <option disabled selected value="">
                          Birth Month
                        </option>
                        {monthOptions}
                      </select>
                    </span>
                    <span
                      className={data.birthDay ? "has-value select" : "select"}
                    >
                      <select
                        name="birthDay"
                        autoComplete="bday-day"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.birthDay || null}
                      >
                        <option disabled selected value="">
                          Day
                        </option>
                        {dayOptions}
                      </select>
                    </span>
                    <span
                      className={data.birthYear ? "has-value select" : "select"}
                    >
                      <select
                        name="birthYear"
                        autoComplete="bday-year"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.birthYear || null}
                      >
                        <option disabled selected value="">
                          Year
                        </option>
                        {yearOptions}
                      </select>
                    </span>
                  </p>
                </fieldset>
                <fieldset>
                  <legend>Your Spouse</legend>
                  <p className="field field-split split-name">
                    <input
                      type="text"
                      name="firstNameSpouse"
                      autoComplete="off"
                      placeholder="First Name"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.firstNameSpouse}
                    />
                    <input
                      type="text"
                      name="lastNameSpouse"
                      placeholder="Last Name"
                      autoComplete="off"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.lastNameSpouse}
                    />
                  </p>
                  <p className="field field-split split-birth">
                    <span
                      className={
                        data.birthMonthSpouse ? "has-value select" : "select"
                      }
                    >
                      <select
                        name="birthMonthSpouse"
                        autoComplete="off"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.birthMonthSpouse || null}
                      >
                        <option disabled selected value="">
                          Birth Month
                        </option>
                        {monthOptions}
                      </select>
                    </span>
                    <span
                      className={
                        data.birthDaySpouse ? "has-value select" : "select"
                      }
                    >
                      <select
                        name="birthDaySpouse"
                        autoComplete="off"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.birthDaySpouse || null}
                      >
                        <option disabled selected value="">
                          Day
                        </option>
                        {dayOptions}
                      </select>
                    </span>
                    <span
                      className={
                        data.birthYearSpouse ? "has-value select" : "select"
                      }
                    >
                      <select
                        name="birthYearSpouse"
                        autoComplete="off"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.birthYearSpouse || null}
                      >
                        <option disabled selected value="">
                          Year
                        </option>
                        {yearOptions}
                      </select>
                    </span>
                  </p>
                </fieldset>
                <h2>Contact Information</h2>
                <fieldset>
                  <legend>Mailing Address</legend>
                  <p className="field">
                    <input
                      type="text"
                      name="address"
                      placeholder="Address"
                      autoComplete="street-address"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.address}
                    />
                  </p>
                  <p className="field field-split">
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      autoComplete="address-level2"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.city}
                    />
                    <input
                      type="text"
                      name="region"
                      placeholder="State/Province/Region"
                      autoComplete="address-level1"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.region}
                    />
                  </p>
                  <p className="field field-split">
                    <input
                      type="text"
                      name="zip"
                      placeholder="Zip/Postal Code"
                      autoComplete="postal-code"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.zip}
                    />
                    <span className="has-value select">
                      <select
                        name="country"
                        autoComplete="country"
                        onChange={this.onSelectChange.bind(this)}
                        defaultValue={data.country || countries[0]}
                      >
                        {countryOptions}
                      </select>
                    </span>
                  </p>
                  <p className="field field-split">
                    <input
                      type="text"
                      name="email"
                      placeholder="Primary Email"
                      autoComplete="email"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.email}
                    />
                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone"
                      autoComplete="tel"
                      onChange={this.onInputChange.bind(this)}
                      defaultValue={data.phone}
                    />
                  </p>
                </fieldset>
                <p className="button-bar full">
                  <button
                    className="btn-primary"
                    onClick={(e) => this.saveAndNext(e)}
                  >
                    Continue
                  </button>
                </p>
              </div>
              <input
                type="hidden"
                name="promo"
                value={isValidPromo ? promo : ""}
              />
              <input
                type="hidden"
                name="upgraded"
                value={isValidUpgrade ? upgraded : ""}
              />
            </form>
          </main>
        )}
        <SiteFooter trip={trip} hideTrips hideNewsletter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/book.js